import { apiRequest, apiRequestFirst } from "./client";

export const affiliatesApi = {
  getSummary() {
    return apiRequestFirst(["/auth/affiliate"]);
  },

  getAdminOverview() {
    return apiRequest("/admin/affiliates");
  },

  updateAdminSettings(payload) {
    return apiRequest("/admin/affiliates/settings", {
      method: "PATCH",
      body: payload,
    });
  },
};
